import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './index.css';
import App from './App';
import Info from './Info';
import Terms from './Terms';
import Privacy from './Privacy';
import Blog from './Blog';
import BlogPost from './BlogPost';
import PlayPage from './PlayPage';
import CreatePage from './CreatePage';
import ExperienceBuilder from './ExperienceBuilder';
import Explore from './Explore';
import CardFound from './CardFound';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/info" element={<Info />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/:slug" element={<BlogPost />} />
        <Route path="/play" element={<PlayPage />} />
        <Route path="/create" element={<CreatePage />} />
        <Route path="/explore" element={<Explore />} />
        <Route path="/experience/:albumId" element={<ExperienceBuilder />} />
        <Route path="/c/:code" element={<CardFound />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
